<template>
  <view>
    <view class="picker-demo-title">Config minute step:</view>
    <cube-time-picker minuteStep="{{minuteStep}}" />
  </view>
</template>

<script>
import { createComponent } from '@mpxjs/core'

createComponent({
  data: {
    minuteStep: {
      rule: 'ceil',
      step: 15
    }
  }
})
</script>

<style lang="stylus">
.picker-demo-title
  margin-bottom: 8px
.event-params,
.demo-data
  margin-top: 10px
  .key
    margin-bottom: 10px
  .value
    margin-bottom: 20px
    white-space: break-spaces
</style>

<script type="application/json">
  {
    "usingComponents": {
      "cube-time-picker": "@mpxjs/mpx-cube-ui/src/components/time-picker/index"
    }
  }
</script>
